/** @flow */
import * as React from 'react';
import { TooltipWrapper, TooltipTitle, TooltipItemList, TooltipItem } from './RechartsToolTipStyles';
import { displayNumber } from '../../Number';


type TooltipProps = {
  active?: boolean;
  label?: string;
  payload?: Array<Object>;
  data: ?Object;
  dataKey: string;
  type?: 'reach' | 'listeningTime';
}

function getValue(value: Object, type) {
  return value;
}

export default function MetricRechartsTooltip({ active, payload, label, data, dataKey, type }: TooltipProps) {
  if (!data || !dataKey) {
    return null;
  }

  const d: Object = data;
  if (active && payload) {
    const items = payload.filter(entry => entry.value)
      .map((entry, i) => {
        let value = entry.value;
        if (entry.dataKey === dataKey) {
          if (d.hasOwnProperty(label)) {
            value = getValue(d[label].current || d[label], type);
          } else if (d.hasOwnProperty('current')) {
            value = getValue(d.current, type);
          } else {
            value = getValue(d, type);
          }
        }
        return (
          <TooltipItem key={`tooltip-item-${entry.dataKey}`} color={entry.color}>{entry.name} : {displayNumber(Number(value), 2)}</TooltipItem>
        );
      });

    return (
      <TooltipWrapper>
        <TooltipTitle>{label}</TooltipTitle>
        <TooltipItemList>{items}</TooltipItemList>
      </TooltipWrapper>
    );
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/common/components/charts/tooltip/MetricRechartsTooltip.js